var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDsvLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 253.67 148.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -22.28,
    y1: 91.16,
    x2: 282.23,
    y2: 91.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#351ec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19d0e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -22.3,
    y1: 74.25,
    x2: 282.23,
    y2: 74.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -22.28,
    y1: 74.25,
    x2: 282.23,
    y2: 74.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -22.28,
    y1: 41.49,
    x2: 282.23,
    y2: 41.49,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.61,65.54c.38,2.81.63,5.68.63,8.71,0,16.15-5.52,29.27-16.55,39.34-5.38,4.87-11.41,8.43-18.08,10.67-6.66,2.12-15.03,3.17-25.09,3.17h-10.1V33.84H0v114.65h30.77c15.07,0,26.71-1.38,34.91-4.14,8.79-2.75,17.18-7.67,25.2-14.71,11.02-9.73,18.14-21.59,21.55-35.47-1.57-2.21-3.11-4.4-4.63-6.56-5.47-7.79-10.77-15.27-16.19-22.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 216.37,
    cy: 74.25,
    r: 15.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.37,68.25C112.92,36.32,87.49.14,37.3.14H0v20.86h37.3c39.35,0,59.58,28.77,81,59.24,22.44,31.93,47.88,68.11,98.06,68.11h37.3v-20.86h-37.3c-39.35,0-59.58-28.77-81-59.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.12,4.43c-9.3,2.88-17.72,7.79-25.3,14.71-10.53,9.61-17.36,21.34-20.65,35.1,1.59,2.23,3.15,4.46,4.69,6.64,5.49,7.8,10.78,15.3,16.21,22.11-.39-2.82-.64-5.7-.64-8.73,0-16.28,5.46-29.49,16.36-39.63,9.8-9.04,24.26-13.55,43.37-13.55l32.51.22V0h-31.16c-14.94,0-26.74,1.47-35.39,4.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsvLogo);
export default __webpack_public_path__ + "static/media/DSV_Logo.d7f1f4491c121a26a2409330a606cfb2.svg";
export { ForwardRef as ReactComponent };